import qs from 'qs';
import {NextProblemRequestArgument} from '@types';
import {parseFiltersDto} from './problemFilterQuery';

const DEFAULT_IGNORED_QUERY_PARAMS = ['lastProblemId', 'excludedIds'];

type BuildNextProblemPathOptions = {
    mergeCurrentSearch?: boolean;
    ignoredQueryParams?: string[];
};

export const buildNextProblemPath = (
    problemId: number,
    argument: NextProblemRequestArgument,
    currentSearch = '',
    options: BuildNextProblemPathOptions = {}
) => {
    const ignoredQueryParams =
        options.ignoredQueryParams ?? DEFAULT_IGNORED_QUERY_PARAMS;
    const nextArgs = Object.fromEntries(
        Object.entries(argument).filter(
            ([, value]) => value !== null && value !== undefined
        )
    );

    const nextQuery = {
        ...(options.mergeCurrentSearch
            ? qs.parse(currentSearch, {ignoreQueryPrefix: true})
            : {}),
        ...nextArgs,
    };
    if (nextQuery.filtersDto) {
        nextQuery.filtersDto = parseFiltersDto(nextQuery.filtersDto);
    }

    const params = qs.stringify(
        nextQuery,
        {
            encode: false,
            skipNulls: true,
            addQueryPrefix: true,
            filter: (prefix, value) =>
                ignoredQueryParams.includes(String(prefix)) ? undefined : value,
        }
    );

    return `/problems/${problemId}${params}`;
};
